import Navbar from "@/components/Navbar";
import SEO from "@/components/SEO";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import QuoteSection from "@/components/QuoteSection";
import RoadmapSection from "@/components/RoadmapSection";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { useTranslation } from "@/i18n/useTranslation";

const meta = {
  en: {
    title: "EastWestIT — Cloud & AI Transformation Consultant",
    description: "Your cloud, modernised. Your AI, governed. Independent Microsoft 365 consulting — cloud migration, Copilot governance and AI agent strategy.",
  },
  da: {
    title: "EastWestIT — Rådgivning i cloud, AI og IT-sikkerhed",
    description: "Uafhængig Microsoft 365-rådgivning: cloud-migrering, Copilot-governance, NIS2 og AI-strategi. Certificeret er ikke det samme som sikker.",
  },
};

const Index = () => {
  const { lang } = useTranslation();
  const m = meta[lang];
  return (
  <div className="min-h-screen">
    <SEO title={m.title} description={m.description} path="/" />
    <Navbar />
    <HeroSection />
    <ServicesSection />
    <QuoteSection />
    <RoadmapSection />
    <AboutSection />
    <ContactSection />
    <Footer />
  </div>
  );
};

export default Index;
